import { GoogleAuthProvider, signInWithRedirect, signInWithPopup,  onAuthStateChanged, OAuthProvider, signOut, deleteUser  } from "firebase/auth";
import { store } from '../store';
import { auth, functions, db } from "./firebase"
import { httpsCallable } from "firebase/functions";
import { doc, setDoc } from "firebase/firestore";


const microsoft = new OAuthProvider('microsoft.com');// Initialize Firebase
const provider = new GoogleAuthProvider();
let name;
let patient_path;
let appointment_path;
let schedule_path;
let uid;
let role;

// Writes the patient_path of a user.
export function writeData(userUid) {
    patient_path = `/physicians/${userUid}/patients`;
    appointment_path = `/physicians/${userUid}/appointments`;
    schedule_path = `/physicians/${userUid}/schedule`;
    uid = userUid;
}

export { patient_path, appointment_path, schedule_path, uid, role }

// Used on the user box widget.
function writeUserName(userName) {
    name = userName
}


AuthStateChanged() // start listening for auth state
/**
 * Listener for changes in the authentication state and recognizes if it's a new user or not.
 * @param {object} auth - authenticates connection between client and database.
 * @param {boolean} user - User info in case successfully logged in.
 * @returns {boolean} authChanged - Whether the authentication was sucessful or failed
 */
export async function AuthStateChanged() {
    let authChanged;
    await auth.onAuthStateChanged(async user => {
        store.authStateKnown = true;
        if (user) {
            let checkUser = httpsCallable(functions, "check_user", {headers: {
                'Authorization': `Bearer ${user.accessToken}`
            }})
            const userStatus = await checkUser( { email: user.email, uid: user.uid} );
            console.log(`### Allowed User: ${userStatus.data.allowedUser}`)
            console.log(`### First Login: ${userStatus.data.firstLogin}`) 
            if (userStatus.data.allowedUser) {
                try {
                    if (userStatus.data.firstLogin) {
                        store.newUser = true;
                        console.log('New User!');
                        try{
                            const writeUser = await setDoc(doc(db, `first_login/${user.uid}`), {
                                name: user.displayName,
                                email: user.email,
                            });               
                        }catch (error){
                            console.log('ERROR: ', error)
                        }
                    } else {
                        console.log(userStatus.data.role)
                        store.newUser = false;
                        store.userRole = userStatus.data.role;
                        role = userStatus.data.role
                        console.log(`User role written: ${userStatus.data.role}`)
                        console.log('firebase')  
                        }
                    writeData(user.uid);
                    writeUserName(user.displayName);
                    authChanged = true;
                    store.user = user;

                } catch (error) {
                    console.error("Error checking first login: ", error);
                }
            }
            else {
                authChanged = false;
                deleteUser(user).then(() => {
                    alert('Not an authorized domain. Contact us at admin@verusamb.com')
                }).catch((error) => {
                    console.log(error)
                });
            }
        } else {
            authChanged = false;
        }
    })
    return authChanged;
}

// Logs user out.
export function FirebaseSignOut() {
    signOut(auth).then(() => {
    }).catch((error) => {
        alert("Something went wrong! Contact admin@verusamb.com for support")
        console.log(error)
    });
}


/**
 * Signing in with Google
 * @param {object} auth - authenticates connection between client and database.
 * @param {boolean} resultOgLogin - whether users is successfully logged in or not
 * @param {object} provider - type of authentication used, Google in this case.
 * @returns {boolean} - Whether the login was successful or not
 */
export async function GoogleSignIn() {
    let resultOfLogin;
    await signInWithPopup(auth, provider)
        .then((result) => {
            // This gives you a Google Access Token. You can use it to access the Google API.
            const credential = GoogleAuthProvider.credentialFromResult(result);
            const token = credential.accessToken;
            // The signed-in user info.
            const user = result.user;
            resultOfLogin = true;
            
        }).catch((error) => {
            // Handle Errors here.
            const errorCode = error.code;
            const errorMessage = error.message;
            // The email of the user's account used.
            const email = error.customData.email;
            // The AuthCredential type that was used.
            const credential = GoogleAuthProvider.credentialFromError(error);
            alert("Something went wrong! Contact admin@verusamb.com for support")
            resultOfLogin = false;
        });
    return resultOfLogin;
}


/**
 * Signing in with Google
 * @param {object} auth - authenticates connection between client and database.
 * @param {boolean} resultOgLogin - whether users is successfully logged in or not
 * @param {object} microsoft - Microsoft authentication.
 * @returns {boolean} - Whether the login was successful or not
 */
export async function MicrosoftSignIn() {
    let resultOfLogin;

    await signInWithPopup(auth, microsoft)
        .then((result) => {
            const credential = OAuthProvider.credentialFromResult(result);
            const accessToken = credential.accessToken;
            const idToken = credential.idToken;
            resultOfLogin = true;
        })
        .catch((error) => {
            resultOfLogin = false;
            alert("Something went wrong! Contact admin@verusamb.com for support")
            console.log(error)
        });

    return resultOfLogin;
}


